export default "__VITE_ASSET__BVXmFutI__"